exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nlabel[data-v-429fc01c] {\n  margin-bottom: 0;\n}\n", ""]);

// exports
